import React from 'react';
import Hero from '../components/Hero';
import StarProducts from '../components/StarProducts';
import PartnersGrid from '../components/PartnersGrid';
import AboutSection from '../components/AboutSection';
import ColorShowcase from '../components/ColorShowcase';
import LabColorWheel from '../components/LabColorWheel';
import BeforeAfterCalibration from '../components/BeforeAfterCalibration';
import ProductsShowcase from '../components/ProductsShowcase';
import SpectroViewer3D from '../components/SpectroViewer3D';
import ExperienceSection from '../components/ExperienceSection';
import ProductCompare from '../components/ProductCompare';
import PortfolioSection from '../components/PortfolioSection';
import VideoTestimonials from '../components/VideoTestimonials';
import PrinterStrip from '../components/PrinterStrip';

const SectionDivider = () => (
  <div className="container-pn py-2">
    <PrinterStrip className="opacity-50" />
  </div>
);

const Home = () => {
  return (
    <main>
      <Hero />
      <StarProducts />
      <PartnersGrid />
      <AboutSection />
      <SectionDivider />
      <ColorShowcase />
      <LabColorWheel />
      <BeforeAfterCalibration />
      <ProductsShowcase />
      <SpectroViewer3D />
      <ExperienceSection />
      <ProductCompare />
      <PortfolioSection />
      <VideoTestimonials limit={3} />
    </main>
  );
};

export default Home;
